import { Badge, Tooltip } from '@chakra-ui/react';
import { IColumn } from '../types';
import { formatDateTimeSafe } from '../../../../../utilities/dateHelpers';
import { ISummaryRecordedInterview, RecordedInterviewSystemStatus } from 'types';
import { defaultHeaderRenderer } from '../headers';
import { CellEventsHandler } from '../formatters';
import { CellProps } from '../../types';
import {
  getRecordedInterviewInfoStatusString,
  getRecordedInterviewInfoStatusColor,
} from '../../../../../utilities/formatting';
import { TableDate, BadgeWrap } from '../styles';

const RecordedInterviewFormatter = (cellProps: CellProps) => {
  const recordedInterviews = cellProps.row.recordedInterviews ?? [];
  const infoStatus = cellProps.row.recordedInterviewSystemStatus || RecordedInterviewSystemStatus.NONE;
  const recordedDate =
    cellProps.row.recordedInterviewTimestamp &&
    cellProps.row.recordedInterviewSystemStatus === RecordedInterviewSystemStatus.RECORDED
      ? formatDateTimeSafe(cellProps.row.recordedInterviewTimestamp, 'DD MMM YYYY HH:mm')
      : '';

  const fullText = recordedInterviews.map((interview: ISummaryRecordedInterview, index: number) => {
    const name = interview.interviewName || '';
    const infoStatus = interview.systemStatus || RecordedInterviewSystemStatus.NONE;
    return (
      <div key={`${interview.interviewId}-${index}`}>{`${name} - ${getRecordedInterviewInfoStatusString(
        infoStatus,
      )}`}</div>
    );
  });

  const { colorScheme, variant } = getRecordedInterviewInfoStatusColor(infoStatus as RecordedInterviewSystemStatus);

  const TextNode = (
    <BadgeWrap>
      <Badge colorScheme={colorScheme} variant={variant}>
        {getRecordedInterviewInfoStatusString(infoStatus as RecordedInterviewSystemStatus)}
      </Badge>

      <TableDate>{recordedDate}</TableDate>
    </BadgeWrap>
  );

  if (recordedInterviews.length > 0) {
    return (
      <CellEventsHandler cellProps={cellProps}>
        <Tooltip hasArrow placement="top-end" label={fullText}>
          {TextNode}
        </Tooltip>
      </CellEventsHandler>
    );
  }
  return <CellEventsHandler cellProps={cellProps}>{TextNode}</CellEventsHandler>;
};

export const RecordedInterviewColumn = (): IColumn => ({
  item: {
    key: 'RecordedInterviews',
    name: 'Recorded interviews',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(136px, 1.25fr)',
    formatter: RecordedInterviewFormatter,
  },
  visible: ({ isRecordedInterviewVisible }) => isRecordedInterviewVisible!,
});
